/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {batchUpdateReactionInternal} from '../api'

export const useMutationBatchUpdateReactionInternal = createReactQueryMutationHook('batchUpdateReactionInternal', batchUpdateReactionInternal)
